import Vue from 'vue'
import get from 'lodash/get'
import replace from 'lodash/replace'
import eachRight from 'lodash/eachRight'

const local = (string, args) => {
  let value = get(window.i18n, string)

  eachRight(args, (paramVal, paramKey) => {
    value = replace(value, `:${paramKey}`, paramVal)
  })

  return value ? value : string
}

if (!Vue.prototype.trans) {
  Vue.prototype.trans = local
}

export default local
